export default [{
  path: '/funnel_dashboard',
  name: 'FunnelDashboard',
  meta: {
    title: 'Funnel Onboarding Dashboard'
  },
  component: function () {
    return import( /* webpackChunkName: "support" */ '../modules/FunnelDashboard/views/FunnelDashboard.vue')
  },
}]